'use strict';

//Component
var _ = require('lodash');
var AppDispatcher = require('../core/AppDispatcher.jsx');
var CHANGE_EVENT = 'change';

//Constants
var Constants = require('../constants/AdviserFeeConstants.js');
var InvAllocationActionTypes = require('../constants/InvestmentAllocationConstants').ActionTypes;
var ProductIds = require('../constants/ApplicationConstants').ProductIds;
var YesNoValues = require('../constants/ApplicationConstants').YesNoValues;
var ContentService = require('../services/ContentService.js');
var ActionTypes = Constants.ActionTypes;
var _model = _.clone(Constants.AdviceFeeData);
var ApplicationConstants = require('../constants/ApplicationConstants');
var ApplicationActionTypes = ApplicationConstants.ActionTypes;

//Utilities
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var Mapper = require('../utils/Mapper.js');
var Validators = require('../utils/Validators.js');
var Formatter = require('../utils/Formatter.js');
var Products = require('../utils/Products.js');

//local variables
var _hideExcessFeeWarning = true,
    _isFeesExcessive = false,
    _finishedAdviserFee = true,
    _notSelectedInvestmentAllocation = true,
    _setupIsValid = false,
    _isSuperTransferSetup = false,
    _showInvAllocationOptions = true,
    _showInSpecieOptions = false,
    _showPredictiveSearch = false;

var _list = _model.AdviceFeesList,
    _investOptionTable = [],
    _inSpecieOptions = [],
    _options = [],
    _formError = [],
    _summaryError = [],
    _fullInvestmentOptionList = [],
    _prevInvestOptionTable = [];

var _accountBalance = 0,
    _showFeeTypeOption = 0,
    _productId,
    _isLoadingComplete = true,
    _missingBalance = false;


//-------------ADVICE FEE FIELD TEMPLATE----------------------//
// id - current index
// feeType - ASF || LSF
// frequency - oneoff || ongoing
// transFacility - Super First Transfer Facility
// penAccount - Pension account
// feeAmount - Fee amount
// adviceFeeDeductionOption - InvstWeight || SelOption
// onGoingType - amt || per || amtper
// onGoingMonthlyAmount - Enter fee amount to be deducted monthly
// onGoingPercentage - Enter percentage of account balance to be deducted per annum
// isCPI - yes || no
// InvestmentAllocationId - Investment allocation selected value
// addAnotherAdviserFee - true || false
//---------------------------------------------------------//

var _customAttributeName = {
    feeType: 'Fee type',
    frequency: 'Frequency',
    transFacility: 'SuperFirst Transfer Facility',
    penAccount: 'Pension account',
    feeAmount: 'Fee amount',
    adviceFeeDeductionOption: 'An answer to How is your advice fee to be deducted?',
    onGoingType: 'An answer to How would you like to set your fee?',
    onGoingMonthlyAmount: 'Amount',
    onGoingPercentage: 'Percentage of account balance to be deducted per annum',
    isCPI: 'Consumer price index',
    investmentAllocationId: 'An investment option from which your advice fee is to be deducted',
    addAnotherAdviserFee: 'An answer to Would you like to add another advice fee?'
};

function getRules() {
    var rules = {
        feeType: 'required',
        frequency: 'required',
        transFacility: 'required_if:penAccount,|currency|currencyMaxLength',
        penAccount: 'required_if:transFacility,|currency|currencyMaxLength',
        feeAmount: 'required|currency|currencyMaxLength',
        adviceFeeDeductionOption: 'required',
        onGoingType: 'required',
        onGoingMonthlyAmount: 'required|currency|currencyMaxLength',
        onGoingPercentage: 'required|currency|percentMaxLength',
        isCPI: 'required',
        investmentAllocationId: 'required',
        addAnotherAdviserFee: 'required'
    };

    return rules;
}

//validation rules
function getValidationRules(fieldId) {
    var allRules = getRules(),
        rulesForField = {};

    if (!fieldId) {
        return allRules;
    }

    if (!allRules[fieldId]) {
        return null;
    }

    rulesForField[fieldId] = allRules[fieldId];

    return rulesForField;
}

function mapInlineErrors(data, idx) {
    if (data.length > 0) {

        _.forEach(data, (n) => {
            let sp = n.id.split('_');

            if (sp.length > 1) {
                n.id = `advFee_${sp[1]}_${sp[2]}`;
            } else {
                n.id = `advFee_${n.id}_${idx}`;
            }
        });
    }
    return data;
}

function clearErrorListForField(idx, fieldName) {

    Validators.clearErrorListForField(_formError, `advFee_${fieldName}_${idx}`);
    Validators.clearErrorListForField(_summaryError, `advFee_${fieldName}_${idx}`);
}

function validateFields(idx, fieldName, fieldValue) {

    var rules = getValidationRules(fieldName),
        data = {};

    if (_showPredictiveSearch) {
        delete rules.investmentAllocationId;
    }

    data[fieldName] = fieldValue;

    let attributes = _.cloneDeep(_customAttributeName);
    let validatedForSuperFirst = false;
    if (_list[idx][Constants.FieldNames.FREQUENCY] === Constants.Frequencies.ONEOFF && _productId === ProductIds.PENSION) {
        if (_isSuperTransferSetup) {
            let inputtedSuperFirstTrans = fieldName === Constants.FieldNames.TRANS_FACILITY;
            let inputtedPensionAccount = fieldName === Constants.FieldNames.PEN_ACCOUNT;
            if (inputtedSuperFirstTrans) {
                data[Constants.FieldNames.PEN_ACCOUNT] = _list[idx][Constants.FieldNames.PEN_ACCOUNT];
            } else if (inputtedPensionAccount) {
                data[Constants.FieldNames.TRANS_FACILITY] = _list[idx][Constants.FieldNames.TRANS_FACILITY];
            }
            if (inputtedSuperFirstTrans || inputtedPensionAccount) {
                validatedForSuperFirst = true;
                clearErrorListForField(idx, Constants.FieldNames.TRANS_FACILITY);
                clearErrorListForField(idx, Constants.FieldNames.PEN_ACCOUNT);
                let ruleTransFacility = getValidationRules(Constants.FieldNames.TRANS_FACILITY);
                let rulePenAccount = getValidationRules(Constants.FieldNames.PEN_ACCOUNT);
                Validators.validateField(data, ruleTransFacility, attributes, _formError, Constants.FieldNames.TRANS_FACILITY);
                Validators.validateField(data, rulePenAccount, attributes, _formError, Constants.FieldNames.PEN_ACCOUNT);
            }
        } else {
            delete rules.transFacility;
            rules.penAccount = 'required|currency|currencyMaxLength';
        }
    }

    if (!validatedForSuperFirst) {
        clearErrorListForField(idx, fieldName);
        Validators.validateField(data, rules, attributes, _formError, fieldName);
    }

    _formError = mapInlineErrors(_formError, idx);

    fieldFormater(idx, fieldName);
}

function fieldFormater(idx, fieldName) {

    switch (fieldName) {
        case Constants.FieldNames.TRANS_FACILITY:
        case Constants.FieldNames.PEN_ACCOUNT:
        case Constants.FieldNames.FEE_AMOUNT:
        case Constants.FieldNames.ONGOING_MONTHLY_AMT:

            let val = _list[idx][fieldName];

            if (val.length > 0 && Validators.currencyValidation(val)) {
                _list[idx][fieldName] = Formatter.currencyFormatWithoutRounding(val);
            }

            break;

        case Constants.FieldNames.ONGOING_PERCENTAGE:

            let per = _list[idx][fieldName];

            if (per.length > 0 && Validators.currencyValidation(per) && per <= 100) {
                _list[idx][fieldName] = Formatter.currencyFormatWithoutRounding(per);
            }

            break;
    }
}

function validateRequiredFields() {
    const copytext = ContentService.getContent().adviceFees;
    if (_setupIsValid) {

        _formError = [];
        _summaryError = [];

        _.forEach(_list, (n, idx) => {

            let si = idx;
            let rules = getSpecificRules(_list[idx]);
            let attributes = _.cloneDeep(_customAttributeName);
            let inlineErrorList = Validators.validateAll(_list[idx], rules, attributes);
            let summary = Validators.validateAll(_list[idx], rules, attributes, '', `${copytext.sectionHeader} #${si + 1}`);

            _formError = _formError.concat(mapInlineErrors(inlineErrorList, idx));
            _summaryError = _summaryError.concat(mapInlineErrors(summary, idx));

        });
    }
}

function validateSummary() {
    const copytext = ContentService.getContent().adviceFees;

    if (_setupIsValid) {
        _.forEach(_list, (n, idx) => {
            let feeType = n.feeType,
                frequency = n.frequency;

            if (feeType && frequency) {
                let duplicates = [];

                _.forEach(_list, (o, i) => {
                    if (o.feeType === feeType && o.frequency === frequency) {
                        duplicates.push(i);
                    }
                });

                if (_.includes(duplicates, idx) && idx !== _.first(duplicates)) {
                    let code;

                    if (feeType === Constants.FeeTypes.ASF) {
                        code = frequency === Constants.Frequencies.ONGOING? Constants.Labels.ASF_ONGOING : Constants.Labels.ASF_ONEOFF;
                    } else {
                        code = Constants.Labels.LSF_ONGOING;
                    }

                    _formError.push({ id: `advFee_feeType_${idx}`, message: Formatter.formatString(copytext.adviceFeeDuplicateInline, { code: code.toLowerCase() }), type: 'error' });
                    _summaryError.push({ id: `advFee_feeType_${idx}`, message: Formatter.formatString(copytext.adviceFeeDuplicateSummary, { code: code.toLowerCase() }), type: 'error', clickable: `${copytext.sectionHeader} #${idx+1}` });

                    _summaryError = _.sortBy(_summaryError, (n) => {
                        return parseInt(n.clickable.replace(`${copytext.sectionHeader} #`, ''));
                    });
                }
            }
        });
    }
}

function getSpecificRules(list) {

    let rules = _.cloneDeep(getRules()),
        field = Constants.FieldNames;

    if (list[field.FEE_TYPE] === '') {
        delete rules.frequency;
        delete rules.transFacility;
        delete rules.penAccount;
        delete rules.feeAmount;
        delete rules.adviceFeeDeductionOption;
        delete rules.onGoingType;
        delete rules.onGoingMonthlyAmount;
        delete rules.onGoingPercentage;
        delete rules.isCPI;
        delete rules.investmentAllocationId;
        delete rules.addAnotherAdviserFee;

    } else if (list[field.FEE_TYPE] && list[field.FREQUENCY] === '') {
        delete rules.transFacility;
        delete rules.penAccount;
        delete rules.feeAmount;
        delete rules.adviceFeeDeductionOption;
        delete rules.onGoingType;
        delete rules.onGoingMonthlyAmount;
        delete rules.onGoingPercentage;
        delete rules.isCPI;
        delete rules.investmentAllocationId;

    } else if (list[field.FEE_TYPE] && list[field.FREQUENCY]) {

        if (list.investmentList.length === 1) {
            delete rules.investmentAllocationId;
        }

        if (list[field.FREQUENCY] === Constants.Frequencies.ONGOING) {

            if (list[field.ONGOING_TYPE] === '') {
                delete rules.onGoingMonthlyAmount;
                delete rules.onGoingPercentage;
                delete rules.isCPI;

            } else if (list[field.ONGOING_TYPE] === Constants.OngoingTypes.AMT) {
                delete rules.onGoingPercentage;

            } else if (list[field.ONGOING_TYPE] === Constants.OngoingTypes.PER) {

                delete rules.onGoingMonthlyAmount;
                delete rules.isCPI;
            }

            delete rules.transFacility;
            delete rules.penAccount;
            delete rules.feeAmount;
            delete rules.adviceFeeDeductionOption;

        } else if (list[field.FREQUENCY] === Constants.Frequencies.ONEOFF) {

            if (_productId === ProductIds.PENSION) {
                delete rules.feeAmount;
                if (!_isSuperTransferSetup) {
                    delete rules.transFacility;
                    rules.penAccount = 'required|currency|currencyMaxLength';
                }
            } else {
                delete rules.transFacility;
                delete rules.penAccount;
            }

            if (list[field.ADVICE_FEE_DE_OPT] === '' || list[field.ADVICE_FEE_DE_OPT] === Constants.DeductionOptions.INVESTMENT_WEIGHTING) {
                delete rules.investmentAllocationId;
            }

            delete rules.onGoingType;
            delete rules.onGoingMonthlyAmount;
            delete rules.onGoingPercentage;
            delete rules.isCPI;
        }
    }

    return rules;
}

function setRenderingFlags() {
    if (!_list) {
        return;
    }
    _.forEach(_list,
        function(value, index) {
            value.isFirstOngoingFee = isFirstOngoingFee(index);
            value.hasSingleInvestmentAllocation = isSingleInvestmentAllocation(index);
        });
}

function loadAdviceFee(adviceFee) {
    if (!adviceFee) {
        return;
    }
    _model.adviceFeeOption = adviceFee.adviceFeeOption;
    _model.IsFeesExcessive = adviceFee.isFeesExcessive;
    _hideExcessFeeWarning = adviceFee.isFeesExcessive ? false : true;
    _isFeesExcessive = adviceFee.isFeesExcessive;
    var adviceFeesList = adviceFee.adviceFeesList;
    var temp = [];
    _notSelectedInvestmentAllocation = true;
    if (adviceFeesList && adviceFeesList.length > 0) {
        _.forEach(adviceFeesList, function (n) {
            if (_notSelectedInvestmentAllocation && Validators.requiredValidation(n.investmentAllocationId)) {
                _notSelectedInvestmentAllocation = false;
            }
            var data = {
                id: n.id, feeType: n.feeType, frequency: n.frequency, transFacility: n.superFirstTransferFacility.toFixed(2),
                penAccount: n.pensionAmount.toFixed(2), feeAmount: n.feeAmount.toFixed(2),
                adviceFeeDeductionOption: n.adviceFeeDeductionOption, onGoingType: n.ongoingType,
                onGoingMonthlyAmount: n.ongoingMonthlyAmount.toFixed(2), onGoingPercentage: n.ongoingAnnualPercentage.toFixed(2),
                isCPI: n.isConsumerPriceIndex, investmentAllocationId: n.investmentAllocationId,
                investmentList: n.investmentList || [], addAnotherAdviserFee: n.addAnotherAdviserFee
            };
            temp.push(data);
        });
        _list = temp;
    }
    setRenderingFlags();
}

function setAddAdviserFee(fieldId, value) {
    _model[fieldId] = Mapper.toTrim(value);
    _hideExcessFeeWarning = true;
    
    if (value === YesNoValues.YES) {
        resetAdviceFeeInvestmentOptions();
        verifyIfAdviceFeeCanBeAdded(_options);
        if (_setupIsValid && _list.length === 0) {
            _list.push({
                id: 0,
                feeType: '',
                frequency: '',
                transFacility: '',
                penAccount: '',
                feeAmount: '',
                adviceFeeDeductionOption: '',
                onGoingType: '',
                onGoingMonthlyAmount: '',
                onGoingPercentage: '',
                isCPI: YesNoValues.NO,
                investmentAllocationId: '',
                addAnotherAdviserFee: '',
                investmentList: [],
                isFirstOngoingFee: false,
                hasSingleInvestmentAllocation: false
            });
        }
    }else {
        _list = [];
        _formError = [];
        _summaryError = [];
        _notSelectedInvestmentAllocation = true;
    }
    _model.IsReset = false;
}

function removeSingleRecord(index) {
    var lastIndex = 0;
    //check if row to be deleted is the first ongoing fee
    var isToBeDeletedFirstOngoing = isFirstOngoingFee(index);
    _list.splice(index, 1); //delete

    for (var i = 0; i < _list.length; i++) {
        _list[i].id = i;
        lastIndex = i;
        //if its the first ongoing fee remove the investment allocation ids of all other ongoing fees
        if (isToBeDeletedFirstOngoing && _list[i].frequency === Constants.Frequencies.ONGOING) {
            _list[i].investmentAllocationId = '';
        }
    }

    //if _list is empty then set adviser fee selection to false
    if (_list.length < 1) {
        _finishedAdviserFee = true;
        _model[Constants.FieldNames.ADD_ADVFEE_OPT] = '';
    } else {
        _list[lastIndex].addAnotherAdviserFee = '';
    }
}


//This function sets the investment allocation id of all Ongoing fees to be the same value.
function setInvestmentOptionForOngoingFees() {
    var asfOngoing = [],
        lsfOngoing = [],
        selectedAsfOption = [],
        selectedLsfOption = [],
        uniqueAsf = [],
        uniqueLsf = [],
        unique = [];

    //get list of ongoing ASF and LSF
    if (_list.length > 0) {
        asfOngoing = _.where(_list, { feeType: Constants.FeeTypes.ASF, frequency: Constants.Frequencies.ONGOING });
        lsfOngoing = _.where(_list, { feeType: Constants.FeeTypes.LSF, frequency: Constants.Frequencies.ONGOING });
    }

    //get selected investment allocation ids
    if (asfOngoing.length > 0) {
        selectedAsfOption = _.map(asfOngoing, Constants.FieldNames.INVESTMENT_ALLOCATION_ID);
    }
    if (lsfOngoing.length > 0) {
        selectedLsfOption = _.map(lsfOngoing, Constants.FieldNames.INVESTMENT_ALLOCATION_ID);
    }

    //get the unique ids
    if (selectedAsfOption.length > 0) {
        uniqueAsf = _.unique(selectedAsfOption);
    }

    if (selectedLsfOption.length > 0) {
        uniqueLsf = _.unique(selectedLsfOption);
    }

    //combine the unique ids for LSF and ASF
    if (uniqueLsf.length > 0 && uniqueAsf.length > 0) {
        if (uniqueLsf[0] === '') {
            unique = _.union(uniqueAsf, uniqueLsf);
        }
        else {
            unique = _.union(uniqueLsf, uniqueAsf);
        }

    }
    else if (uniqueAsf.length > 0 && uniqueLsf.length === 0) {
        unique = uniqueAsf;
    }
    else if (uniqueLsf.length > 0 && uniqueAsf.length === 0) {
        unique = uniqueLsf;
    }

    //set the investment allocation id of all advice fees that are ongoing to the unique value
    if (unique.length > 0) {
        for (var i = 0; i < _list.length; i++) {
            if ((_list[i].feeType === Constants.FeeTypes.ASF && _list[i].frequency === Constants.Frequencies.ONGOING && _list.adviceFeeDeductionOption !== Constants.DeductionOptions.INVESTMENT_WEIGHTING) || _list[i].feeType === Constants.FeeTypes.LSF) {
                _list[i].investmentAllocationId = unique[0];
            }
        }
    }
}

function setAdditionalAdviserFee(val) {
    if (val === YesNoValues.YES) {

        _list.push({
            id: 0, feeType: '', frequency: '', transFacility: '',
            penAccount: '', feeAmount: '', adviceFeeDeductionOption: '', onGoingType: '',
            onGoingMonthlyAmount: '', onGoingPercentage: '', isCPI: YesNoValues.NO, investmentAllocationId: '', addAnotherAdviserFee: '',
            investmentList: [], isFirstOngoingFee: false, hasSingleInvestmentAllocation: false
        });

        var index = _list.length - 1;

        _list[index].id = index;

        _finishedAdviserFee = true;

        _.remove(_formError, (o) => { return _.endsWith(o.id, index.toString()); });

    } else if (val === YesNoValues.NO && _list.length > 0) {
        _finishedAdviserFee = false;

        _formError = [];
        _summaryError = [];
    }
}


function calculateTotalOneOffFeeAmount(oneoffFeeAmount, oneoffPensionAmount, oneoffTransFacility) {
    var total = 0;
    if (oneoffFeeAmount) {
        total = total + oneoffFeeAmount;
    }
    if (oneoffPensionAmount) {
        total = total + oneoffPensionAmount;
    }
    if (oneoffTransFacility) {
        total = total + oneoffTransFacility;
    }
    return total;
}

function excessiveFeeCheck(accountBalance, ongoingTotals, oneOffTotals) {
    var adviceFeeAPI = require('../apis/AdviceFeeAPI.js');
    var oneOffFee = 0, ongoingFee = 0, ongoingPercent = 0;

    if (oneOffTotals) {
        oneOffFee = calculateTotalOneOffFeeAmount(oneOffTotals.feeAmount, oneOffTotals.pensionAmount, oneOffTotals.transFacility);
    }
 
    if (ongoingTotals) {
        ongoingFee = ongoingTotals.monthly;
        ongoingPercent = ongoingTotals.percent;
    }

    adviceFeeAPI.excessiveFeeCheck(accountBalance, oneOffFee, ongoingFee, ongoingPercent);
}

function loadInvestmentAllocationTable(list) {
    _investOptionTable = list;
    setOptions();
    resetAdviceFeeInvestmentOptions();
    verifyIfAdviceFeeCanBeAdded(_options);
    if (_model.adviceFeeOption === YesNoValues.YES && _setupIsValid && _list.length === 0) {
        _list.push({
            id: 0,
            feeType: '',
            frequency: '',
            transFacility: '',
            penAccount: '',
            feeAmount: '',
            adviceFeeDeductionOption: '',
            onGoingType: '',
            onGoingMonthlyAmount: '',
            onGoingPercentage: '',
            isCPI: YesNoValues.NO,
            investmentAllocationId: '',
            addAnotherAdviserFee: '',
            investmentList: [],
            isFirstOngoingFee: false,
            hasSingleInvestmentAllocation: false
        });
    }
    for (var i = 0; i < _list.length; i++) {
        generateInvestmentOptionList(i, _list[i].frequency);
        if (_prevInvestOptionTable.length !== list.length) {
            _list[i].investmentAllocationId = '';
        }
        setSingleInvestmentOptionId(i, _list[i].frequency);
        clearErrorListForField(i, Constants.FieldNames.INVESTMENT_ALLOCATION_ID);
    }
    _prevInvestOptionTable = _.cloneDeep(list);
}

function resetAdviceFeeInvestmentOptions() {
    if (_options.length > 0) {
        if (_model.AdviceFeesList.length > 0) {
            for (var i = 0; i < _model.AdviceFeesList.length; i++) {
                _model.AdviceFeesList[i].investmentList = _options;
            }
        }
    } else {
        _list = [];
        _formError = [];
        _summaryError = [];
        _notSelectedInvestmentAllocation = true;
        _hideExcessFeeWarning = true;
    }
    _model.IsReset = true;
}

function resetAdviceFeeAmounts() {
    if (_accountBalance > 0) {
        //reset do you want to add an advice fee if the missing balance message is shown.
        if (_missingBalance) {
           // _model.adviceFeeOption = '';
            _missingBalance = false;
        }
        if (_model.AdviceFeesList.length > 0) {
            _.forEach(_model.AdviceFeesList, function (n) {
                n.transFacility = '';
                n.feeAmount = '';
                n.penAccount = '';
                n.onGoingMonthlyAmount = '';
                n.onGoingPercentage = '';
            });
        }
        if (_list.length > 0) {
            _.forEach(_list, function (n) {
                n.transFacility = '';
                n.feeAmount = '';
                n.penAccount = '';
                n.onGoingMonthlyAmount = '';
                n.onGoingPercentage = '';
            });
        }
    } else if (_model.adviceFeeOption === YesNoValues.YES) {
       // _model.adviceFeeOption = '';
        _list = [];
        _formError = [];
        _summaryError = [];
        _notSelectedInvestmentAllocation = true;
    }
    _model.IsReset = true;
    _hideExcessFeeWarning = true;
}

function setInspecieData(data) {
    if (Products.isPension(_productId) && data.inSpecieModel) {
        var newShowInvAllocationOptions = data.inSpecieModel.setUp === YesNoValues.NO ||
        (data.inSpecieModel.setUp === YesNoValues.YES &&
            data.inSpecieModel.externalAccountQuestion !== YesNoValues.YES);
        var newShowInSpecieOptions = data.inSpecieModel.setUp === YesNoValues.YES;
        var isInSpecieSwitched = _showInvAllocationOptions !== newShowInvAllocationOptions ||
            _showInSpecieOptions !== newShowInSpecieOptions;

        _showInvAllocationOptions = newShowInvAllocationOptions;
        _showInSpecieOptions = newShowInSpecieOptions;

        var accounts = data.inSpecieAccounts ? _.cloneDeep(data.inSpecieAccounts) : [];
        var investmentOptions = _.flatten(_.map(accounts, 'investmentOptions'));
        _inSpecieOptions = _.reduce(investmentOptions, function (result, value) {
            if (_.isString(value)) {
                value = value.replace(/,/g, '');
            }
            if (!_.find(result, { id: value.id }) && parseFloat(value.balance) > 0) {
                result.push(value);
            }
            return result;
        }, []);

        let needReset = false;
        if (isInSpecieSwitched) {
            // last setUp option is not the same as the new one, reset options
            needReset = true;
        }

        if (_showInSpecieOptions) {
            _showPredictiveSearch = _.some(accounts,
                function (o) {
                    return o.isExistingAccount === false;
                });

            if (_showPredictiveSearch) {
                needReset = true;
            }
        } else {
            _showPredictiveSearch = false
        }

        setOptions();
        resetAdviceFeeInvestmentOptions();
        verifyIfAdviceFeeCanBeAdded(_options);
        if (needReset) {
            for (var i = 0; i < _list.length; i++) {
                generateInvestmentOptionList(i, _list[i].frequency);
                _list[i].investmentAllocationId = '';
                setSingleInvestmentOptionId(i, _list[i].frequency);
                clearErrorListForField(i, Constants.FieldNames.INVESTMENT_ALLOCATION_ID);
            }
        }

        if (_model.adviceFeeOption === YesNoValues.YES && _setupIsValid && _list.length === 0) {
            _list.push({
                id: 0,
                feeType: '',
                frequency: '',
                transFacility: '',
                penAccount: '',
                feeAmount: '',
                adviceFeeDeductionOption: '',
                onGoingType: '',
                onGoingMonthlyAmount: '',
                onGoingPercentage: '',
                isCPI: YesNoValues.NO,
                investmentAllocationId: '',
                addAnotherAdviserFee: '',
                investmentList: [],
                isFirstOngoingFee: false,
                hasSingleInvestmentAllocation: false
            });
        }
    } else {
        _showInvAllocationOptions = true; //default is show inv allocation options only
        _showInSpecieOptions = false;
    }
}

function setOptions() {
    if (_showPredictiveSearch && _showInSpecieOptions) {
        _options = _.cloneDeep(_fullInvestmentOptionList);
    }else if (_showInvAllocationOptions && _showInSpecieOptions) {
        _options = _.cloneDeep(_investOptionTable);
        _.forEach(_inSpecieOptions,
            function (s) {
                if (!_.find(_options, { id: s.id })) {
                    _options.push(s);
                }
            });
    } else if (_showInvAllocationOptions) {
        _options = _.cloneDeep(_investOptionTable);
    } else if (_showInSpecieOptions) {
        _options = _.cloneDeep(_inSpecieOptions);
    } else {
        _options = []
    }
}

function getOngoingTotals() {
    var ongoing = [];
    if (_list.length > 0) {
        ongoing = _.where(_list, { frequency: Constants.Frequencies.ONGOING });
    }

    //get fee amounts from list of ongoing fees
    var monthlyAmounts = _.map(ongoing, Constants.FieldNames.ONGOING_MONTHLY_AMT);
    //get pension amounts from list of ongoing fees
    var annualPercentages = _.map(ongoing, Constants.FieldNames.ONGOING_PERCENTAGE);

    //get totals of each
    var monthly = 0, percent = 0;
    if (monthlyAmounts && monthlyAmounts.length > 0) {
        convertToNumbers(monthlyAmounts);
        monthly = _.sum(monthlyAmounts);
    }
    if (annualPercentages && annualPercentages.length > 0) {
        convertToNumbers(annualPercentages);
        percent = _.sum(annualPercentages);
    }

    var totals = {
        monthly: monthly,
        percent: percent
    };

    return totals;
}

function convertToNumbers(list) {
    for (var i = 0; i < list.length; i++) {
        list[i] = Formatter.currencyUnformat(list[i]);
    }
}

function getOneOffTotals() {
    var oneoff = [];
    //get all one off fees
    if (_list.length > 0) {
        oneoff = _.where(_list, { frequency: Constants.Frequencies.ONEOFF });
    }

    //get fee amounts from list of one off fees
    var oneOffFeeAmounts = _.map(oneoff, Constants.FieldNames.FEE_AMOUNT);
    //get pension amounts from list of one off fees
    var pensionAmounts = _.map(oneoff, Constants.FieldNames.PEN_ACCOUNT);
    //get trans facitity amounts from list of one off fees
    var transFacilities = _.map(oneoff, Constants.FieldNames.TRANS_FACILITY);

    //get totals of each
    var feeAmount = 0, pensionAmount = 0, transFacility = 0;
    if (oneOffFeeAmounts && oneOffFeeAmounts.length > 0) {
        convertToNumbers(oneOffFeeAmounts);
        feeAmount = _.sum(oneOffFeeAmounts);
    }
    if (pensionAmounts && pensionAmounts.length > 0) {
        convertToNumbers(pensionAmounts);
        pensionAmount = _.sum(pensionAmounts);
    }
    if (transFacilities && transFacilities.length > 0) {
        convertToNumbers(transFacilities);
        transFacility = _.sum(transFacilities);
    }

    var totals = {
        feeAmount: feeAmount,
        pensionAmount: pensionAmount,
        transFacility: transFacility
    };
    return totals;
}

function performExcessiveFeeCheck() {
    //get totals
    var oneOffTotals = getOneOffTotals();
    var ongoingTotals = getOngoingTotals();

    //perform excessive fee check
    excessiveFeeCheck(_accountBalance, ongoingTotals, oneOffTotals);
}

function getExcessiveFeeCheckResult(result) {
    if (result) {
        _hideExcessFeeWarning = true;
        _isFeesExcessive = false;
    }
    else {
        _hideExcessFeeWarning = false;
        _isFeesExcessive = true;
    }
    _isLoadingComplete = true;
}

function setAccountBalance(balance) {
    _accountBalance = balance;
    resetAdviceFeeAmounts();
    verifyIfAdviceFeeCanBeAdded(_options);
}

function generateInvestmentOptionList(index, frequency) {

    var templist = _list;

    var filterList = _.where(templist, { frequency: frequency });

    if (_list[index].investmentList.length > 0) {
        _list[index].investmentList = [];
    }

    if (filterList.length > 1 && frequency === Constants.Frequencies.ONGOING) {
        _.forEach(_options, function (n) {
            var data;
            data = { code: n.code, id: n.id, name: n.name, disabled: true };
            _list[index].investmentList.push(data);
        });
    }
    else {

        _.forEach(_options, function (n) {
            var data = { code: n.code, id: n.id, name: n.name, disabled: false };
            _list[index].investmentList.push(data);

        });
    }
}

function setFeeType(idx) {

    var selectedFields = _.cloneDeep(Constants.FieldNames);

    delete selectedFields.FEE_TYPE;
    delete selectedFields.ADD_ANOTHER_ADVISER;

    _.forEach(selectedFields, (n) => {
        _list[idx][n] = '';
        clearErrorListForField(idx, n);
    });
    _list[idx][Constants.FieldNames.IS_CPI] = YesNoValues.NO;
}

function setFrequency(idx) {
    var selectedFields = _.cloneDeep(Constants.FieldNames);

    delete selectedFields.FEE_TYPE;
    delete selectedFields.FREQUENCY;
    delete selectedFields.ADD_ANOTHER_ADVISER;

    _.forEach(selectedFields, (n) => {
        _list[idx][n] = '';
        clearErrorListForField(idx, n);
    });

    _list[idx][Constants.FieldNames.IS_CPI] = YesNoValues.NO;

    //if there are any ongoing fees they should have the same investment option to deduct fees from
    setInvestmentOptionForOngoingFees();
}

function setOnGoingType(idx) {
    _list[idx][Constants.FieldNames.ONGOING_MONTHLY_AMT] = '';
    _list[idx][Constants.FieldNames.ONGOING_PERCENTAGE] = '';
    _list[idx][Constants.FieldNames.IS_CPI] = YesNoValues.NO;

    clearErrorListForField(idx, Constants.FieldNames.ONGOING_MONTHLY_AMT);
    clearErrorListForField(idx, Constants.FieldNames.ONGOING_PERCENTAGE);
}

function setDeductionOption(idx, value) {
    _list[idx][Constants.FieldNames.INVESTMENT_ALLOCATION_ID] = '';

    setSingleInvestmentOptionId(idx, value);

    clearErrorListForField(idx, Constants.FieldNames.INVESTMENT_ALLOCATION_ID);
    clearErrorListForField(idx, Constants.FieldNames.INVESTMENT_ALLOCATION_ID);
}

function setSingleInvestmentOptionId(idx, value) {
    if (_list[idx].investmentList.length === 1) {
        if (value === Constants.DeductionOptions.SELECT_OPTION || value === Constants.Frequencies.ONGOING) {
            _list[idx][Constants.FieldNames.INVESTMENT_ALLOCATION_ID] = _list[idx].investmentList[0].id;
        }
    }
}

function setInvestmentAllocationId(index, value) {
    //if user changes the investment allocation of the first ongoing (LSF or ASF) we update the other ongoing fees.    
    if (_list[index].frequency === Constants.Frequencies.ONGOING) {
        if (_list.length > 1) {
            for (var i = 0; i < _list.length; i++) {
                if ((_list[i].feeType === Constants.FeeTypes.ASF && _list[i].frequency === Constants.Frequencies.ONGOING
                        && _list.adviceFeeDeductionOption !== Constants.DeductionOptions.INVESTMENT_WEIGHTING)
                        || _list[i].feeType === Constants.FeeTypes.LSF) {

                    _list[i].investmentAllocationId = value;
                }
            }
        }
        _notSelectedInvestmentAllocation = false;
    }
}

//if ASF & LSF is enable active type = 0
//if ASF & not LSF active type = 1
//if not ASF & enable LSF = 2
//if not ASF & not LSF = 3
function setAdviserFeeTypeOptions(data) {
    var opt = 0;

    if (data) {
        var asf = data.adviserServiceFeePayable,
            lsf = data.licenseeServiceFeePayable;

        if (asf && !lsf) {
            opt = 1;
        } else if (!asf && lsf) {
            opt = 2;
        } else if (!asf && !lsf) {
            opt = 3;
        }
    }
    _showFeeTypeOption = opt;
}

function setProductId(productId) {
    _productId = productId;
}

function setupSuperTransfer(response, fromRetrieve) {
    let isSuperTransferSetup = response === YesNoValues.YES;
    if (_isSuperTransferSetup != isSuperTransferSetup && _productId === ProductIds.PENSION && !fromRetrieve) {


        _.forEach(_list, function(f, idx) {
            if (f.frequency === Constants.Frequencies.ONEOFF) {
                _list[idx][Constants.FieldNames.TRANS_FACILITY] = '';
            }
            if (f.transFacility.length === 0) {
                clearErrorListForField(idx, Constants.FieldNames.TRANS_FACILITY);
            }
            if (f.penAccount.length === 0) {
                clearErrorListForField(idx, Constants.FieldNames.PEN_ACCOUNT);
            }
        });
    }

    _isSuperTransferSetup = isSuperTransferSetup;
}

function isFirstOngoingFee(id) {
    var ongoing = [],
        isFirst = false;

    if (_list.length > 0) {

        ongoing = _.where(_list, { frequency: Constants.Frequencies.ONGOING });

        if (ongoing.length > 0) {
            isFirst = ongoing[0].id === id;
        }
    }

    return isFirst;
}

function excessiveFeeCheckOnUpdate() {
    if (_formError.length === 0) {
        _isLoadingComplete = false;
        performExcessiveFeeCheck();
    }
}

function updateAdviceFee(idx, fieldId, value) {
    _list[idx][fieldId] = Mapper.toTrim(value);

    validateFields(idx, fieldId, value);

    switch (fieldId) {
        case Constants.FieldNames.FEE_TYPE:
            setFeeType(idx);
            break;
        case Constants.FieldNames.FREQUENCY:
            setFrequency(idx);
            generateInvestmentOptionList(idx, value);
            setSingleInvestmentOptionId(idx, value);
            break;
        case Constants.FieldNames.ONGOING_TYPE:
            setOnGoingType(idx);
            break;
        case Constants.FieldNames.TRANS_FACILITY:
            excessiveFeeCheckOnUpdate();
            break;
        case Constants.FieldNames.PEN_ACCOUNT:
            excessiveFeeCheckOnUpdate();
            break;
        case Constants.FieldNames.FEE_AMOUNT:
            excessiveFeeCheckOnUpdate();
            break;
        case Constants.FieldNames.ONGOING_MONTHLY_AMT:
            excessiveFeeCheckOnUpdate();
            break;
        case Constants.FieldNames.ONGOING_PERCENTAGE:
            excessiveFeeCheckOnUpdate();
            break;
        case Constants.FieldNames.ADD_ANOTHER_ADVISER:
            setAdditionalAdviserFee(_list[idx].addAnotherAdviserFee);
            _isLoadingComplete = false;
            performExcessiveFeeCheck();
            break;
        case Constants.FieldNames.ADVICE_FEE_DE_OPT:
            setDeductionOption(idx, value);
            break;
        case Constants.FieldNames.INVESTMENT_ALLOCATION_ID:
            setInvestmentAllocationId(idx, value);
            break;
        default:
            break;
    }
}

function isSingleInvestmentAllocation(index) {
    return _list[index].investmentList.length === 1;
}


function verifyIfAdviceFeeCanBeAdded(data) {
    
    if (window.NOA.userContext.isAdviser) {
        if (_accountBalance === 0 && _model.adviceFeeOption === YesNoValues.YES) {
            _setupIsValid = false;
            _missingBalance = true;
        }
        else if (data.length === 0 && _model.adviceFeeOption === YesNoValues.YES) {            
            _setupIsValid = false;
        }
        else {
            _setupIsValid = false;
            clearErrorListForField(0, 'adviceFeeOption');
        }
    }
}

function setFullInvestmentOptionList(investmentOptionList) {
    _fullInvestmentOptionList = _.cloneDeep(investmentOptionList);
    _.forEach(_fullInvestmentOptionList,
        function(o) {
            _.assign(o, { label: o.code.trim() ? o.name + ' - ' + o.code : o.name }, { value: o.id });
        });
    _.sortBy(_fullInvestmentOptionList, 'label');
}

function retrieveAccountBalance(form) {
    if (form.fundingYourProduct) {
        setAccountBalance(form.fundingYourProduct.totalAmount);
    }
}

function retrieveSuperFirstData(superFirstData) {
    if (superFirstData) {
        var isSuperFirst = superFirstData.isSuperTransferSetup === ApplicationConstants.isTrue
            ? ApplicationConstants.YesNoValues.YES
            : ApplicationConstants.YesNoValues.NO;
        setupSuperTransfer(isSuperFirst, true);
    }
}

var AdviceFeeStore = assign({}, EventEmitter.prototype, {

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },

    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },

    getAdviserConfiguration: function () {
        return _list;
    },

    getSelectedAdviserFee: function (index) {
        if (_list[index]) {
            _list[index].isFirstOngoingFee = isFirstOngoingFee(index);
            _list[index].hasSingleInvestmentAllocation = isSingleInvestmentAllocation(index);
        }
        return _list[index];
    },

    getInvestmentTableIndex: function (index) {
        let result = _.find(_list, { id: index });
        if (result) {
            return _list[index].investmentList;
        }
    },

    hideExcessFeeWarning: function () {
        return _hideExcessFeeWarning;
    },

    getAccountBalance: function () {
        return _accountBalance;
    },

    finishedAdviserFee: function () {
        return _finishedAdviserFee;
    },

    adviceFeeErrorMessages: function () {
        return _summaryError;
    },

    getFeeTypeEnableOption: function () {
        return _showFeeTypeOption;
    },

    getHasNotSelectedInvestmentAllocation: function () {
        return _notSelectedInvestmentAllocation;
    },

    isSuperTransferSetup: function () {
        return _isSuperTransferSetup;
    },

    getAdviceFeeModel: function () {

        var formModel = {
            adviceFeeOption: _model.adviceFeeOption,
            IsFeesExcessive: false,
            AdviceFeesList: []
        };

        formModel.IsFeesExcessive = _isFeesExcessive;

        if (_list.length > 0) {
            _.forEach(_list, function (n) {
                formModel.AdviceFeesList.push({
                    id: n.id,
                    feeType: n.feeType,
                    frequency: n.frequency,
                    superFirstTransferFacility: n.transFacility,
                    pensionAmount: n.penAccount,
                    feeAmount: n.feeAmount,
                    adviceFeeDeductionOption: n.adviceFeeDeductionOption,
                    onGoingType: n.onGoingType,
                    onGoingMonthlyAmount: n.onGoingMonthlyAmount,
                    ongoingAnnualPercentage: n.onGoingPercentage,
                    IsConsumerPriceIndex: n.isCPI,
                    investmentAllocationId: n.investmentAllocationId,
                    investmentList: n.investmentList,
                    addAnotherAdviserFee: n.addAnotherAdviserFee
                });
            });
        }

        return formModel;
    },

    getAdviceFeeModelData: function () {
        return _model;
    },

    getAdviserServiceFeeFlag:function(){
        return _model.adviceFeeOption;
    },

    getFormError: function () {
        return _formError;
    },

    getIsLoadingComplete: function() {
        return _isLoadingComplete;
    },

    getShowPredictiveSearch: function() {
        return _showPredictiveSearch;
    },

    getFullInvestmentOptionList: function () {
        return _fullInvestmentOptionList;
    },

    getIsOneOffFeeExist: function() {
        return _.some(_list, function(f) {
            return f[Constants.FieldNames.FREQUENCY] === Constants.Frequencies.ONEOFF;
        })
    }
});

AdviceFeeStore.dispatchToken = AppDispatcher.register(function (action) {

    switch (action.actionType) {
        case ActionTypes.ADD_ADVISER_FEE:
            setAddAdviserFee(action.fieldId, action.value);
            break;
        case ApplicationActionTypes.SEND_FUNDING_AMOUNT:
            setAccountBalance(action.balance);
            break;
        case ActionTypes.GET_EXCESSIVE_FEE_CHECK_RESULT: //API
            getExcessiveFeeCheckResult(action.result);
            break;
        case ActionTypes.REMOVE_SINGLE_RECORD:
            removeSingleRecord(action.index);
            break;
        case ApplicationActionTypes.SET_ADVISER_FEE_TYPE_OPTIONS: //API
            setAdviserFeeTypeOptions(action.data);
            break;
        case InvAllocationActionTypes.RECEIVE_INVESTMENT_OPTION_LIST:
            setFullInvestmentOptionList(action.investmentOptionList);
            break;
        case ApplicationActionTypes.NEW_APPLICATION_INITIALISED:
            setProductId(action.productId);
            break;
        case ApplicationActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            setProductId(action.applicationData.productId);
            retrieveAccountBalance(action.applicationData.form);
            loadAdviceFee(action.applicationData.form.adviceFee);
            setInspecieData({
                inSpecieAccounts: _.get(action, 'applicationData.form.inSpecieTransfer.inSpecieAccounts', null),
                inSpecieModel: _.get(action, 'applicationData.form.inSpecieTransfer', null)
            });
            retrieveSuperFirstData(action.applicationData.form.superFirstTransfer);
            break;
        case ApplicationActionTypes.SEND_IS_SUPER_FIRST_TRANSFER:
            setupSuperTransfer(action.value, false);
            break;
        case ApplicationActionTypes.VALIDATE_APPLICATION:
            validateRequiredFields();
            validateSummary();
            break;
        case ActionTypes.UPDATE_ADVICE_FEE:
            updateAdviceFee(action.idx, action.fieldId, action.value);
            break;
        case ApplicationActionTypes.SEND_INVESTMENT_OPTIONS:
            loadInvestmentAllocationTable(action.investmentOptionList);
            break;
        case ApplicationActionTypes.SEND_INSPECIE_DATA:
            setInspecieData(action.data);
            break;
        default:
            return true;
    }
    AdviceFeeStore.emitChange();
    return true;
});
module.exports = AdviceFeeStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/AdviceFeeStore.js